import {
    temAcesso
} from '@/shared/auth/temAcesso'

const Atestos = () => import('./Atestos.vue')
const AtestoForm = () => import('./AtestoForm.vue')
// const ContratoApostilar = () => import('./apostilamento/ContratoApostilar.vue')
// const ContratoResponsavelForm = () => import('./responsaveis/ContratoResponsavelForm.vue')

export default {
    path: 'atestos',
    name: 'Atestos',
    component: Atestos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-ATESTOS-00')) {
            next()
        }
    },
    children: [
        // {
        //     path: 'inserir',
        //     name: 'Usuarios_Inserir',
        //     component: UsuarioForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CTRLACS-USR-01')) {
        //             next()
        //         }
        //     }
        // },
        {
            path: ':atestoId',
            name: 'Atestos_Detalhar',
            component: AtestoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-ATESTOS-00')) {
                    next()
                }
            }
        },
        // {
        //     path: ':contratoId/apostilar',
        //     name: 'Contratos_Apostilar',
        //     component: ContratoApostilar,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso('CONT-APOST-01')) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/responsavel/:responsavelId',
        //     name: 'Contratos_Responsavel_Atualizar',
        //     component: ContratoResponsavelForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso(['CONT-APOST-03'])) {
        //             next()
        //         }
        //     }
        // },
        // {
        //     path: ':contratoId/responsavel',
        //     name: 'Contratos_Responsavel_Inserir',
        //     component: ContratoResponsavelForm,
        //     beforeEnter: (to, from, next) => {
        //         if (temAcesso(['CONT-APOST-03'])) {
        //             next()
        //         }
        //     }
        // }
    ]
}
